import { useEffect, useRef } from 'react';
import config from '../config';

const TawkToChat = () => {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = config.tawkToSrc;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');

    document.head.appendChild(s1);

    const style = document.createElement('style');
    style.id = 'tawkto-fix';

    style.textContent = `
      html,
      body,
      #root,
      .App,
      .app,
      .page-wrapper,
      .main {
        overflow: visible !important;
      }

      div[id*="tawk"],
      div[class*="tawk"],
      iframe[src*="tawk"],
      iframe[id*="tawk"] {
        position: fixed !important;
        bottom: 220px !important;
        right: 20px !important;
        left: auto !important;
        z-index: 2147483647 !important;
        min-width: 80px !important;
        min-height: 80px !important;
        max-width: none !important;
        max-height: none !important;
        overflow: visible !important;
        clip: auto !important;
        transform: none !important;
        margin: 0 !important;
        padding: 0 !important;
        visibility: visible !important;
        display: block !important;
      }

      div[id*="tawk"] *,
      div[class*="tawk"] *,
      iframe[src*="tawk"] *,
      iframe[id*="tawk"] * {
        overflow: visible !important;
        clip: auto !important;
        visibility: visible !important;
      }

      @media (max-width: 768px) {
        div[id*="tawk"],
        div[class*="tawk"],
        iframe[src*="tawk"],
        iframe[id*="tawk"] {
          bottom: 100px !important;
          right: 10px !important;
          min-width: 60px !important;
          min-height: 60px !important;
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }
      }
    `;

    document.head.appendChild(style);

    window.Tawk_API.onLoad = function () {
      setTimeout(() => {
        const isMobile = window.innerWidth <= 768;
        const bottomPos = isMobile ? '100px' : '220px';
        const rightPos = isMobile ? '10px' : '20px';

        const iframe = document.querySelector('iframe[src*="tawk"]');

        if (iframe) {
          iframe.style.position = 'fixed';
          iframe.style.right = rightPos;
          iframe.style.bottom = bottomPos;
          iframe.style.zIndex = '2147483647';
          iframe.style.maxHeight = 'none';
          iframe.style.maxWidth = 'none';
          iframe.style.overflow = 'visible';
          iframe.style.clip = 'auto';
          iframe.style.visibility = 'visible';
          iframe.style.display = 'block';
          iframe.style.opacity = '1';
          iframe.style.pointerEvents = 'auto';
        }

        const wrappers = document.querySelectorAll(
          'div[id*="tawk"], div[class*="tawk"]'
        );
        wrappers.forEach((wrapper) => {
          wrapper.style.position = 'fixed';
          wrapper.style.bottom = bottomPos;
          wrapper.style.right = rightPos;
          wrapper.style.left = 'auto';
          wrapper.style.zIndex = '2147483647';
          wrapper.style.overflow = 'visible';
          wrapper.style.clip = 'auto';
          wrapper.style.visibility = 'visible';
          wrapper.style.display = 'block';
          wrapper.style.opacity = '1';
          wrapper.style.pointerEvents = 'auto';
          wrapper.style.maxHeight = 'none';
          wrapper.style.maxWidth = 'none';
        });
      }, 1500);
    };

    return () => {
      const styleEl = document.getElementById('tawkto-fix');
      if (styleEl) {
        styleEl.remove();
      }
    };
  }, []);

  return null;
};

export default TawkToChat;
